module.exports = __webpack_public_path__ + "assets/dacb5ab66adac1b5f13910371dbeb404.png";